/**
 * Группирует элементы массива по некоторому ключу
 * @param arr Массив
 * @param keyGetter Функция для получения ключа группы
 * @returns Сгруппированные по ключам элементы массива
 * @example
 * ```typescript
 * import { groupArrayBy } from '@direct-frontend/stdlib';
 *
 * // {
 * //     a: [{ name: 'a', value: 1 }, { name: 'a', value: 2 }],
 * //     b: [{ name: 'b', value: 1 }, { name: 'b', value: 2 }],
 * // }
 *
 * groupArrayBy(
 *    [
 *        { name: 'a', value: 1 },
 *        { name: 'a', value: 2 },
 *        { name: 'b', value: 1 },
 *        { name: 'b', value: 2 },
 *    ],
 *    (item) => item.name
 * );
 * ```
 */
export function groupArrayBy(arr, keyGetter) {
    return arr.reduce((acc, item) => {
        const key = keyGetter(item);
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(item);
        return acc;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
    }, {});
}
